// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__38WSf","dragIcon":"SortableItem_dragIcon__3y2ow","disabled":"SortableItem_disabled__1wKOg"};